import constants from "constants";

const { CPD_STATUSES, REF_TYPES } = constants;

export const webinar = function (object) {
  const isCertificateOfParticipation =
    object.ref_type === REF_TYPES.CERTIFICATE_OF_PARTICIPATION;

  const isNMBI = object.ref_type === REF_TYPES.NMBI;

  const isCustomCertificate = isCertificateOfParticipation || isNMBI;

  let constraints = {
    webinar_type: {
      presence: true,
    },
    webinar_title: {
      presence: {
        allowEmpty: false,
        // message: '^Can’t be blank'
      },
    },
    status: {
      presence: true,
    },
    // sponsor_id: {
    //   presence: true
    // },
    ...(isCustomCertificate
      ? {}
      : {
          cpd_points: {
            presence: true,
          },
        }),
    vimeo_url: {
      // format: {
      //   // pattern: /^\d{5,}\/[0-9]{5,}/,
      //   minimum: 1,
      //   message: '^Vimeo uid should contain only digits with up to 9 length'
      // }
      ...(object.webinar_type === "recorded"
        ? {
            presence: {
              message:
                "^Vimeo uid should contain only digits with up to 9 length",
            },
          }
        : {}),
    },
    zoom_account: {
      ...(object.webinar_type === "online"
        ? { presence: { message: "Zoom account can't be blank" } }
        : {}),
    },
    counties: {
      presence: {
        message: "^Counties can't be blank",
      },
      length: {
        minimum: 1,
        message: "^Counties can't be blank",
      },
    },
    ...(object.user_types &&
    object.user_types.length === 1 &&
    object.user_types[0] === 11
      ? {}
      : {
          disciplines: {
            presence: {
              message: "^Disciplines can't be blank",
            },
            length: {
              minimum: 1,
              message: "^Disciplines can't be blank",
            },
          },
        }),
    user_types: {
      presence: {
        message: "^User types can't be blank",
      },
      length: {
        minimum: 1,
        message: "^User types can't be blank",
      },
    },
    ...(object.cpd_status === CPD_STATUSES.granted &&
    object.ref_type === REF_TYPES.ICGP
      ? {
          gms_study_days: {
            presence: {
              allowEmpty: false,
            },
          },
        }
      : {}),
  };

  if (object.cpd_status !== CPD_STATUSES.granted) {
    return constraints;
  }

  const companyNameValidation = {
    presence: {
      message: "^Company Name: can’t be blank",
    },
  };

  const cpdNumberValidation = {
    presence: {
      allowEmpty: false,
      message: "^Can’t be blank",
    },
    numericality: true,
  };

  const zoomIdValidation = {
    presence: true,
    format: {
      pattern: /^\d{5,}$/,
      message: "^Zoom uid should contain only digits with up to 9 length",
    },
  };

  switch (object.cpd_points) {
    case "internal":
      constraints = {
        ...constraints,
        ...(isCustomCertificate ? {} : { int_cpd_points: cpdNumberValidation }),
      };
      break;
    case "external":
      constraints = {
        ...constraints,
        ...(isCustomCertificate ? {} : { ext_cpd_points: cpdNumberValidation }),
      };
      break;
    case "both":
      constraints = {
        ...constraints,
        ...(isCustomCertificate
          ? {}
          : {
              int_cpd_points: cpdNumberValidation,
              ext_cpd_points: cpdNumberValidation,
            }),
      };
      break;
  }

  switch (object.webinar_type) {
    case "online":
      constraints = {
        ...constraints,
        zoom_uid: zoomIdValidation,
      };
      break;
    case "recorded":
      break;
  }

  switch (object.user_type) {
    case "sponsor":
      constraints = {
        ...constraints,
        company_name: companyNameValidation,
      };
      break;
    default:
      break;
  }

  return constraints;
};



// WEBPACK FOOTER //
// ./src/validators/webinar.js